import { mapBasicPathToIntegrated } from './pathCompatibility'

// ★ redirectURI 소비 지점 단일 가드
//   redirectURI 는 외부에서 들어오는 입력 — open-redirect 공격 / 베이직 학생앱 path 잔재 모두 처리해야 함.
//
//   정책:
//     1. null / 빈 값 → null
//     2. 절대 URL ('http://...') → null (open redirect 차단)
//     3. 프로토콜 상대 URL ('//attacker.com/path') → null (open redirect 차단)
//     4. javascript:, data:, mailto: 같은 scheme → null
//     5. '/' 로 시작하는 path → 베이직 학생앱 path 면 통합 학생앱 path 로 매핑, 통합 path 는 그대로
export const resolveSafeRedirectURI = (raw: string | null | undefined): string | null => {
  if (!raw) return null
  if (!raw.startsWith('/')) return null // 절대 URL / scheme: 거부
  if (raw.startsWith('//')) return null // 프로토콜 상대 URL 거부
  return mapBasicPathToIntegrated(raw)
}

// ★ root path ('/') 진입 시에만 redirectURI query 를 소비.
export const resolveRootRedirect = (requestUrl: string): string | null => {
  const url = new URL(requestUrl)
  if (url.pathname !== '/') return null
  return resolveSafeRedirectURI(url.searchParams.get('redirectURI'))
}
